// eslint-disable-next-line no-redeclare
/* global google */
export const MIN_RADIUS_ZOOM_LEVEL = 10;
export const MAX_ZOOM_LEVEL = 11;
export const INIT_ZOOM_LEVEL = 6;
export const METERS_IN_MILE = 1609.34;

export const MAX_LAT = 90;
export const MAX_LNG = 180;

export const CLOSE_FULLSCREEN_MAP_VIEW_ANIMATION_LENGTH = 250;
export const DEFAULT_MAP_ID = 'map';

export const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
	gestureHandling: 'greedy',
	mapTypeControl: false,
	maxZoom: MAX_ZOOM_LEVEL,
	streetViewControl: false,
	styles: [
		{
			featureType: 'poi.business',
			stylers: [{ visibility: 'off' }],
		},
	],
	zoom: INIT_ZOOM_LEVEL,
};

export const CIRCLE_OPTIONS: google.maps.CircleOptions = {
	fillColor: '#1D1D1B',
	fillOpacity: 0.2,
	radius: METERS_IN_MILE * 3,
	strokeOpacity: 0,
};

export const DISABLED_INTERACTIONS_CONFIG = {
	disableDoubleClickZoom: true,
	draggable: false,
	scrollwheel: false,
};

export const ENABLED_INTERACTIONS_CONFIG = {
	disableDoubleClickZoom: false,
	draggable: true,
	scrollwheel: true,
};
